<template>
  <div
    style="background: black"
    :class="{ debug: debug }"
    :style="{
      top: marginVertical + 'px ',
      bottom: marginVertical + 'px ',
      left: +marginHorizontal + 'px',
      right: +marginHorizontal + 'px'
    }"
  >
    <warning-message
      v-if="!screen.loaded"
      is-loading-message
    >
      {{ $t('status.loading') }}
    </warning-message>
    <warning-message
      v-else-if="todaysNowPlayingAndUpcomingShowings.length == 0"
    >
      {{ $t('showing.noShowingsToday') }}
    </warning-message>
    <div v-else-if="screen && currentShowing">
      <!-- We have a movie and showtimes-->
      <div
        style="height: 100vh; overflow: hidden;"
        class="row"
      >
        <div class="col">
          <img
            :src="currentShowingImageUrl"
          >
        </div>
        <div class="col-7">
          <div
            class="column"
            style="height: 100vh; justify-content: space-between;"
          >
            <div
              class="row"
            >
              <div
                class="col"
                style="max-width: 60vw"
              >
                <img
                  v-if="showLogo"
                  :src="currentSite.lightLogoImageUrl"
                  :style="logoStyle"
                >
              </div>
            </div>
            <div
              v-if="showScreenName"
              class="row"
            >
              <div
                class="col text-center text-white"
                style="font-weight: 800; font-size: 5.0vw; line-height: 1;"
              >
                {{ currentShowing.screen.name }}
              </div>
            </div>
            <div
              v-if="showMovieName"
              class="row"
            >
              <div
                class="col text-center text-white ellipsis-3-lines q-px-sm"
                :style="movieTitleStyle"
              >
                {{ currentShowing.movie.name }}
              </div>
            </div>
            <div class="row">
              <div class="col text-white">
                <template v-if="currentSite.signageConfig.display_rating">
                  <rated
                    v-if="currentShowing.movie.rating"
                    :rated="currentShowing.movie.rating"
                    :rating-reason="currentShowing.movie.ratingReason"
                    :outline="false"
                    :color="'transparent'"
                    :text-color="'white'"
                    :size="'2vw'"
                    :no-margin="false"
                    light-text
                    :highlight-r-rated="highlightRRated"
                    :disable-official-symbol="disableOfficialSymbol"
                    class="text-bold q-px-lg"
                  />
                  <q-chip
                    v-if="showRatingReason && currentShowing.movie.ratingReason"
                    class="text-bold q-pa-sm"
                    square
                    color="transparent"
                    text-color="white"
                    size="2.2vw"
                    dense
                    style="border: solid 2px;"
                  >
                    <div style="white-space: normal; font-size: 1.3vw; line-height: 1;">
                      {{ currentShowing.movie.ratingReason }}
                    </div>
                  </q-chip>
                </template>
                <template v-if="showShowingBadges">
                  <showing-badge
                    v-for="showingBadge in currentShowing.showingBadges.data"
                    :key="showingBadge.id"
                    size="2vw"
                    :showing-badge="showingBadge"
                    color="white"
                  />
                </template>
              </div>
            </div>

            <div
              class="row"
              style="display: block;"
            >
              <div
                class="col text-center text-white q-pb-sm"
                style="font-weight: 800; font-size: 4.5vw"
              >
                {{ currentShowing.siteTime.format('h:mm a') }}
              </div>
              <div
                class="col text-center text-grey q-pb-xl"
                style="font-weight: 800; font-size: 2vw;"
              >
                Ends {{ currentShowing.siteEndTime.format("h:mm a") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <warning-message
      v-else-if="errorOccurred"
    >
      An error occurred
    </warning-message>
    <warning-message
      v-else-if="!screen"
    >
      {{ `Unknown Screen - ${$route.params && $route.params.screenId}` }}
    </warning-message>
    <warning-message
      v-else
    >
      Unknown Error
    </warning-message>
  </div>
</template>

<script>
import { imgixHost } from 'src/config'
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'
import Rated from 'src/modules/consumer/components/Rated'
import WarningMessage from 'src/modules/signage/components/WarningMessage'
import CurrentShowingsSignageMixin from 'src/modules/signage/mixins/CurrentShowingsSignageMixin'
import ShowingsSignageConfigurationMixin from 'src/modules/signage/mixins/ShowingsSignageConfigurationMixin'
import { inject } from 'vue'

export default {
  name: 'ScreenLandscape',
  components: {
    ShowingBadge,
    Rated,
    WarningMessage
  },
  mixins: [CurrentShowingsSignageMixin, ShowingsSignageConfigurationMixin],
  props: {
    screenId: {
      type: Number,
      required: false,
      default () {
        const route = inject('route')
        return route?.params?.screenId
      }
    },
    showScreenName: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && route.query['show-screen-name'] === 'true') || false
      }
    },
    showRatingReason: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return !((route?.query && route.query['show-rating-reason'] === 'false'))
      }
    },
    showMovieName: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return !(route?.query && route.query['show-movie-name'] === 'false')
      }
    },
    showShowingBadges: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return !(route?.query && route.query['show-showing-badges'] === 'false')
      }
    }
  },
  data () {
    return {
      errorOccurred: false,
      moreBefore: false,
      moreAfter: false
    }
  },
  models: {
    screen: {
      fields: ['id', 'name', 'color'],
      todaysShowings: {
        movie: 'default',
        screen: 'default',
        showingBadges: 'default',
        withinSignageThreshold: true
      },
      variables () {
        return {
          id: this.screenId
        }
      },
      immediate: true
    }
  },
  computed: {
    currentShowingImageUrl () {
      return `${imgixHost}/${this.currentShowing.movie.posterImage}` + '?fit=fit&fm=jpeg&auto=format&cs=origin&w=' + (this.$q.screen.width / 10) * 4 + '&h=' + this.$q.screen.height
    },
    logoStyle () {
      if (this.showScreenName) {
        return 'max-width: 90vw; max-height: 10vh;'
      } else {
        return 'max-width: 90vw; max-height: 30vh;'
      }
    },
    movieTitleStyle () {
      const style = []
      if (this.showScreenName) {
        style.push('font-weight: 400; line-height: 1.2')
      } else {
        style.push('font-weight: 800; line-height: 1.2')
      }
      const movieNameLetterCount = this.currentShowing.movie.name.length

      if (movieNameLetterCount > 50) {
        style.push('font-size : 3vw')
      } else if (movieNameLetterCount > 25) {
        style.push('font-size : 4vw')
      } else {
        style.push('font-size : 4.8vw')
      }
      return style.join(';')
    }

  },
  created () {
    _.extend(this, { ShowingBadge })
  },
  async mounted () {
    this.intervalId = setInterval(() => {
      this.screen.fetch(true)
    }, 5 * 60 * 1000)

    await this.screen.fetch()

    // Fetching the screen when in the app mode of digital-signage, sets the site_id cookie
    // This will reload the configuration data after being authenticated
    this.$handleAuthChange()
  },
  unmounted () {
    if (this.intervalId) clearInterval(this.intervalId)
  }
}

</script>

<style scoped>

.debug .poster-and-showings-container > div {
  border: solid 1px red;
}

.main-display {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  flex-direction: column;
}

.site-logo {
  max-width: 50vw;
  max-height: 10vh;
}
</style>
